// extracted by mini-css-extract-plugin
export var avatarContainer = "_8g-0";
export var avatarTypingWave = "_8g-i";
export var gray = "_8g-f";
export var green = "_8g-c";
export var icon = "_8g-9";
export var image = "_8g-1";
export var lg = "_8g-6";
export var md = "_8g-5";
export var presenceDot = "_8g-b";
export var red = "_8g-d";
export var sm = "_8g-4";
export var status = "_8g-a";
export var typingDot = "_8g-h";
export var typingPill = "_8g-g";
export var xl = "_8g-7";
export var xs = "_8g-3";
export var xxl = "_8g-8";
export var xxs = "_8g-2";
export var yellow = "_8g-e";